import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Team from './pages/Team';
import Events from './pages/Events';
import Contact from './pages/Contact';
import Alumni from './pages/Alumni';
import Sponsors from './pages/Sponsors';
import Scholars from './pages/Scholars';
import Register from './pages/Register';
import Roster from './pages/Roster';
import Apparel from './pages/Apparel';
import Tribute from './pages/Tribute';
import AdminLogin from './pages/AdminLogin';
import AdminScholars from './pages/AdminScholars';
import AdminOrders from './pages/AdminOrders';
import AdminInventory from './pages/AdminInventory';
import AdminSeason from './pages/AdminSeason';
import AdminProducts from './pages/AdminProducts';
import AdminAnnouncements from './pages/AdminAnnouncements';
import AdminPowerRankings from './pages/AdminPowerRankings';
import AdminAccount from './pages/AdminAccount';
import PaymentSuccess, { PaymentCancel } from './pages/PaymentSuccess';
import AdminFundraisers, { AdminRegistrations } from './pages/AdminFundraisers';
import AdminWeeklyText from './pages/AdminWeeklyText';
import PictureDay from './pages/PictureDay';
import AdminCoachAccounts from './pages/AdminCoachAccounts';
import AdminChampions from './pages/AdminChampions';
import AdminAlumniGallery from './pages/AdminAlumniGallery';
import AdminContributors from './pages/AdminContributors';
import AdminEvents from './pages/AdminEvents';
import IceTimes from './pages/IceTimes';
import Announcements from './pages/Announcements';
import AdminIceTimes from './pages/AdminIceTimes';
import Contribute from './pages/Contribute';
import AnnouncementPopup from './components/AnnouncementPopup';
import { CoachChat } from './components/CoachChat';
import WelcomeGreeter from './components/WelcomeGreeter';
import { Toaster } from './components/ui/toaster';
import { InstallPrompt, OfflineBanner } from './components/InstallPrompt';
import { useToast } from './hooks/use-toast';
import { iceLogo } from './mock';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function RouteViewportClass() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.body.dataset.appArea = pathname.startsWith('/admin/') ? 'admin' : 'public';
  }, [pathname]);
  return null;
}

function RouteAwareWelcomeGreeter() {
  const { pathname } = useLocation();
  const uninterruptedRoutes = ['/apparel', '/register', '/contact'];
  const blocksFlow = pathname.startsWith('/admin/') || pathname === '/roster' || pathname.startsWith('/contribute/') || uninterruptedRoutes.includes(pathname);
  return blocksFlow ? null : <WelcomeGreeter />;
}

function PublicLayout({ children }) {
  const { pathname } = useLocation();
  const suppressWidgets = ['/roster', '/apparel', '/register'].includes(pathname);
  const suppressAnnouncements = ['/announcements', '/events', '/apparel', '/register', '/contact'].includes(pathname);
  return (
    <>
      <OfflineBanner />
      <Navbar />
      {children}
      <Footer />
      {!suppressWidgets && <CoachChat />}
      {!suppressWidgets && !suppressAnnouncements && <AnnouncementPopup />}
      {!suppressWidgets && <InstallPrompt />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <RouteViewportClass />
        <RouteAwareWelcomeGreeter />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/scholars" element={<AdminScholars />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/inventory" element={<AdminInventory />} />
          <Route path="/admin/season" element={<AdminSeason />} />
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/announcements" element={<AdminAnnouncements />} />
          <Route path="/admin/power-rankings" element={<AdminPowerRankings />} />
          <Route path="/admin/account" element={<AdminAccount />} />
          <Route path="/admin/fundraisers" element={<AdminFundraisers />} />
          <Route path="/admin/registrations" element={<AdminRegistrations />} />
          <Route path="/admin/weekly-text" element={<AdminWeeklyText />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/admin/coaches" element={<AdminCoachAccounts />} />
          <Route path="/admin/champions" element={<AdminChampions />} />
          <Route path="/admin/alumni-gallery" element={<AdminAlumniGallery />} />
          <Route path="/admin/contributors" element={<AdminContributors />} />
          <Route path="/admin/events" element={<AdminEvents />} />
          <Route path="/admin/football-practice-times" element={<AdminIceTimes />} />
          <Route path="/admin/ice-times" element={<Navigate to="/admin/football-practice-times" replace />} />
          <Route path="/contribute/:token" element={<Contribute />} />
          <Route path="*" element={
            <PublicLayout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/team" element={<Team />} />
                <Route path="/picture-day" element={<PictureDay />} />
                <Route path="/events" element={<Events />} />
                <Route path="/announcements" element={<Announcements />} />
                <Route path="/football-practice-times" element={<IceTimes />} />
                <Route path="/ice-times" element={<Navigate to="/football-practice-times" replace />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/alumni" element={<Alumni />} />
                <Route path="/sponsors" element={<Sponsors />} />
                <Route path="/scholars" element={<Scholars />} />
                <Route path="/register" element={<Register />} />
                <Route path="/roster" element={<Roster />} />
                <Route path="/apparel" element={<Apparel />} />
                <Route path="/tribute" element={<Tribute />} />
              </Routes>
            </PublicLayout>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
